/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)


/* CLOSE ICON */
export const CloseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHECK ICON */
export const CheckIcon = ({ size = 12 }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6 9 17l-5-5" />
    </svg>
)

/* PLUS ICON */
export const PlusIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M12 5v14M5 12h14" />
    </Icon>
)

/* EDIT ICON */
export const EditIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M11 4H7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-4" />
        <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
    </Icon>
)

/* KEY ICON */
export const KeyIcon = ({ size }) => (
    <Icon size={size}>
        <circle cx="8" cy="15" r="4" />
        <path d="m10.8 12.2 8-8M17 3l4 4M14.5 6.5l3 3" />
    </Icon>
)

/* CLOCK ICON */
export const ClockIcon = ({ size }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
    </Icon>
)

/* PULSE ICON */
export const PulseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M3 12h4l2.5-7 4 14L16 12h5" />
    </Icon>
)

/* TRASH ICON */
export const TrashIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" />
        <path d="M10 11v5M14 11v5" />
    </Icon>
)

/* LOCK ICON */
export const LockIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="4" y="11" width="16" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </Icon>
)

/* GLOBE ICON */
export const GlobeIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18" />
    </Icon>
)

/* INFO ICON */
export const InfoIcon = ({ size }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 8h.01" />
    </Icon>
)

/* CROWN ICON — SUPERADMIN ROLE */
export const CrownIcon = ({ size = 18 }) => (
    <Icon size={size}>
        <path d="M3 8l4 3.5L12 5l5 6.5L21 8l-1.8 10.5H4.8L3 8Z" />
    </Icon>
)

/* SHIELD ICON — MANAGER ROLE */
export const ShieldIcon = ({ size = 18 }) => (
    <Icon size={size}>
        <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6Z" />
    </Icon>
)

/* CHIP ICON — PITBOSS ROLE */
export const ChipIcon = ({ size = 18 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="3.5" />
        <path d="M12 3v3M12 18v3M3 12h3M18 12h3" />
    </Icon>
)

/* EYE ICON — VIEWER ROLE */
export const EyeIcon = ({ size = 18 }) => (
    <Icon size={size}>
        <path d="M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6-10-6-10-6Z" />
        <circle cx="12" cy="12" r="2.5" />
    </Icon>
)

/* USERS ICON — EMPTY STATE */
export const UsersIcon = ({ size = 40 }) => (
    <Icon size={size}>
        <path d="M16 20v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 20v-2a4 4 0 0 0-3-3.87M16 3.13A4 4 0 0 1 16 11" />
    </Icon>
)


/* ROLE ICONS BY SLUG */
export const ROLE_ICONS = {
    superadmin: CrownIcon,
    manager: ShieldIcon,
    pitboss: ChipIcon,
    viewer: EyeIcon,
}
